<template>
  <v-row class="page-breadcrumb">
    <v-col cols="12" sm="12" class="pa-0">
      <v-card class="px-2 custom-shaodow">
        <v-toolbar dense flat class="transparent pa-0" height="40px">
          <v-toolbar-title class="pt-3">
            <span class="text--primary">{{ title }}</span>
          </v-toolbar-title>
          <v-toolbar-title
            class="toobar-extension transparent pb-3"
            slot="extension"
          >
            <v-breadcrumbs :items="breadcrumbs" class="pa-0">
              <template v-slot:divider v-if="breadcrumbs">
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>

            <slot></slot>
          </v-toolbar-title>
          
          <v-spacer></v-spacer>
          <v-btn
            v-if="btn_History_show"
            class="mr-3 mt-12"
            depressed
            fab
            small
            dark
            :color="'error'"
            @click.end="goToHistory"
          >
            <v-icon dark>mdi-clipboard-text</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "BaseBreadcrumb",
  props: {
    title: String,
    breadcrumbs: Array,
    icon: String,
    btn_History_show: Boolean,
    toHistory: String,
    oldpage: Object
  },
  computed: {
    ...mapState(['datapage']),
  },
  data: () => ({}),
  methods:{
    ...mapMutations({
      setPage: "SET_DATAPAGE"
    }),
    goToHistory(){
      let path = this.toHistory.split('/');
      console.log(path);
      let newPage = {
        page: 'History',
        typesensor: path[2],
        sensor: path[3],
        routename: path[4],
        header: path[5],
        factory: path[6],
        pump: path[7],
        oldpage: this.oldpage
      }
      this.setPage(newPage);
      //this.$router.replace(this.toHistory);
    }
  }
};
</script>
<style lang="scss">
.page-breadcrumb {
  margin: -24px -25px 27px -25px;
}
</style>